import qs from 'qs'
import { onMounted } from 'vue'
import router from '@/routes/index'

import nativeHybrid from '@/util/nativeHybrid'
import util from '@/util/util'

// 记录网络状态变化
const networkStatusList = []
export const handleNetworkChange = status => {
	try {
		// 由于网络状态变化频繁，只记录最近5次的网络状态
		networkStatusList.push(status)
		if (networkStatusList.length > 5) {
			networkStatusList.shift()
		}
		// 最后一次网络状态
		const currentStatus = networkStatusList[networkStatusList.length - 1]
		// 相邻状态不一致
		const c1 = currentStatus !== networkStatusList[networkStatusList.length - 2]

		const list = ['No Connection', 'unknow_net_status']

		// 无网
		if (c1 && list.includes(currentStatus)) {
			// 在线包，弹出提示
			if (!util.isOfflinePackage()) {
				nativeHybrid.showToast('网络异常，请稍后重试')
				return
			}

			const params = {
				is_nav_show: false,
				wv: 'lg',
				type: 'network_error',
				desc: encodeURIComponent('网络异常，请稍后重试')
			}
			router.push(`/system-busy?${qs.stringify(params)}`).catch(error => {
				console.log(`router push systemBusy error:`, error)
			})
		}
	} catch (error) {
		console.error(error)
	}
}

const bindRegisterEvents = () => {
	try {
		nativeHybrid.registerOnNetWorkChange(status => {
			handleNetworkChange(status)
		})
	} catch (error) {
		console.error('init bindRegisterEvents', error)
	}
}

function useNetwork() {
	onMounted(() => {
		bindRegisterEvents()
	})
}

export default useNetwork
export { bindRegisterEvents }
